import React from 'react';

function MusicToggle({ isPlaying, onToggle }) {
    return (
        <button
            type="button"
            className={`music-toggle ${isPlaying ? 'playing' : 'muted'}`}
            onClick={onToggle}
            aria-label={isPlaying ? 'Disattiva la musica' : 'Attiva la musica'}
            aria-pressed={!isPlaying}
            title={isPlaying ? 'Disattiva la musica' : 'Attiva la musica'}
        >
            <svg className="music-toggle-icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M11 5 6.5 9H3v6h3.5L11 19V5z" />
                {isPlaying ? (
                    <>
                        <path d="M15.5 8.5a4.5 4.5 0 0 1 0 7" className="music-wave" />
                        <path d="M18 6a8 8 0 0 1 0 12" className="music-wave" />
                    </>
                ) : (
                    <path d="M16 9.5l5 5m0-5l-5 5" className="music-wave" />
                )}
            </svg>
        </button>
    );
}

export default MusicToggle;
